import AccountSettings from "./routes/AccountSettings";
import ApplicationDetails from "./routes/ApplicationDetails";
import ApplicationPaymentsDetails from "./routes/ApplicationPaymentsDetails";
import ApplicationPresentationAdd from "./features/ApplicationPresentationAdd";
import ApplicationPresentationEdit from "./features/ApplicationPresentationEdit";
import ApplicationRoot from "./routes/Root/ApplicationRoot";
import Contests from "./routes/Contests";
import firebaseConfig from "./firebase";
import Groups from "./routes/Groups";
import Participants from "./routes/Participants";
import React from "react";
import ResetPassword from "./routes/ResetPassword";
import Root from "./routes/Root/Root";
import SignUp from "./routes/SignUp";
import ThankYouPage from "./routes/ThankYouPage";
import Theme from "./theme/theme";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { LocalizationProvider } from "@mui/x-date-pickers";

export const app = initializeApp(firebaseConfig, "registration");
export const db = getFirestore(app);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <Contests />,
      },
      {
        path: "/contests",
        element: <Contests />,
        children: [],
      },
      {
        path: "/account/settings",
        element: <AccountSettings />,
        children: [],
      },
      {
        path: "/contests/:contestId/applications/:applicationId",
        element: <ApplicationRoot />,
        children: [
          {
            path: "details",
            element: <ApplicationDetails />,
            children: [],
          },
          {
            path: "paymentsDetails",
            element: <ApplicationPaymentsDetails />,
            children: [],
          },

          {
            path: "categories/:categoryId/presentations/new",
            element: <ApplicationPresentationAdd />,
            children: [],
          },
          {
            path: "categories/:categoryId/presentations/:presentationId",
            element: <ApplicationPresentationEdit />,
            children: [],
          },
        ],
      },
      {
        path: "/participants",
        element: <Participants />,
        children: [],
      },
      {
        path: "/groups",
        element: <Groups />,
        children: [],
      },
    ],
  },
  {
    path: "/sign-up",
    element: <SignUp />,
    children: [],
  },
  {
    path: "/resetPassword",
    element: <ResetPassword />,
    children: [],
  },
  {
    path: "/thank-you",
    element: <ThankYouPage />,
    children: [],
  },
]);

export default function App() {
  const theme = Theme();

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <RouterProvider router={router} />
        </LocalizationProvider>
      </ThemeProvider>
    </React.Fragment>
  );
}
